import { useQuery, useQueryClient } from "react-query";
import { useAgentsHttp } from "../useAgentsHttp";
import { QK } from "../queryKeys";
import type { Project } from "../models/project";

interface ProjectsListResponse {
  projects: Project[];
}

const QUERY_KEY = QK.projectsList;

export const useProjectsList = (customer_code?: string) => {
  const http = useAgentsHttp();
  return useQuery<Project[]>(
    [QUERY_KEY, customer_code ?? null],
    async () => {
      const resp = await http<ProjectsListResponse>("/projects/list", {
        ...(customer_code ? { customer_code } : {}),
      });
      return resp.projects;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  );
};

export const useInvalidateProjectsList = () => {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: [QUERY_KEY] });
};
